import React from 'react'
import "./css/Navbar.css"
import { Link } from "react-router-dom"

function Navbar({ setCarts }) {



  return (
    <div className='nav' id='pagetop'>
      <Link to="/"> <div className='logo-location'>
        <img 
        className='logo' src="https://i.ibb.co/4VpKjxJ/Logo.png" alt="Logo" />
        <p className='location'>
          <i class="fas fa-map-marker-alt"></i>
        </p>
      </div>
      </Link>
      <input type="text" placeholder='Search for a Dish' />
      <i class="fas fa-search" className='navi'></i>
      <div className='cart-buttons'>
        <div>
          <i class="fas fa-cart-arrow-down"></i>
          <p className='bbtnn' onClick={() => setCarts(true)}>Cart</p>
        </div>
        <div>
          <i class="far fa-credit-card"></i>
          <Link to="/myaccount/credits"><p className='bbtnn'>Credits</p></Link>
        </div>
        <div>
          <i class="fas fa-user"></i>
          <Link to="/myaccount/orders"><p className='bbtnn'>Guest</p></Link>
        </div>
      </div>
    </div>
  )
}

export default Navbar